import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SubmitAuthCodeFacade } from '@user/data-access';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

/**
 * Так как у нас нет стейта отправки api-запроса для входа через смс,
 * реализовали диспатч состояний в interceptor-е.
 */
@Injectable({ providedIn: 'root' })
export class SubmitAuthCodeInterceptor implements HttpInterceptor {
  constructor(private submitSmsCodeFacade: SubmitAuthCodeFacade) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let isCode = false;
    let isError = false;

    if (req.url.includes('/oauth/token') && req.body?.get?.('client_id')) {
      const username = req.body.get('username');

      if (username) {
        const userNameWithTypeArray = username.split('&');
        isCode = userNameWithTypeArray[1] === 'true' || req.body.get('access_type') === 'access_code';

        if (isCode) {
          const code = req.body.get('password');
          this.submitSmsCodeFacade.submitAuthCode(code);
        }
      }

      return next.handle(req).pipe(
        catchError((error) => {
          isError = true;
          if (isCode) {
            this.submitSmsCodeFacade.submitAuthCodeError(error);
          }

          return throwError(() => error);
        }),
        finalize(() => {
          if (isCode && !isError) {
            this.submitSmsCodeFacade.submitAuthCodeSuccess();
          }
        }),
      );
    } else {
      return next.handle(req);
    }
  }
}
